import { getCurrentPlanMatchLimit } from './get-current-plan-match-limit';

export const checkIfMatchLimitReached = (
  currentCount?: number,
  plan?: object,
  totalRequests?: number
): boolean => {
  return (currentCount || 0) >= getCurrentPlanMatchLimit(plan || [], totalRequests);
};
